export default __webpack_public_path__ + "static/media/186.fb2fff9c.png";